import React, {
  useState,
  useEffect,
} from "react";

import {
  Link,
  useLocation,
} from "react-router-dom";

import {
  FaFacebookF,
  FaYoutube,
  FaEnvelope,
  FaMapMarkerAlt,
  FaPhoneAlt,
} from "react-icons/fa";

import {
  HiOutlineMenuAlt3,
} from "react-icons/hi";

import {
  IoClose,
} from "react-icons/io5";

import logo from "./exellentkidslogo.jpg";
// import logo from "./zpa.png";

import "./NavbarZionPraise.css";


/*
 * =====================================================
 * NAVIGATION LINKS
 * =====================================================
 */

const navLinks = [
  {
    text: "Home",
    path: "/",
  },



  {
    text: "Campus",
    path: "/campusPage",
  },

  {
    text: "Scan Attendance",
    path: "/teacherAttendanceScanner",
  },

  {
    text: "Login",
    path: "/login",
    button: true,
  },
];


const Navbar = () => {

  /*
   * =====================================================
   * LOCATION
   * =====================================================
   */

  const location = useLocation();


  /*
   * =====================================================
   * STATE
   * =====================================================
   */

  const [
    menuOpen,
    setMenuOpen,
  ] = useState(false);

  const [
    scrolled,
    setScrolled,
  ] = useState(false);


  /*
   * =====================================================
   * CLOSE MOBILE MENU WHEN ROUTE CHANGES
   * =====================================================
   */

  useEffect(() => {

    setMenuOpen(false);

  }, [
    location.pathname,
  ]);


  /*
   * =====================================================
   * HANDLE NAVBAR SCROLL
   * =====================================================
   */

  useEffect(() => {

    const handleScroll = () => {

      setScrolled(
        window.scrollY > 25
      );

    };


    window.addEventListener(
      "scroll",
      handleScroll
    );


    return () =>
      window.removeEventListener(
        "scroll",
        handleScroll
      );

  }, []);


  /*
   * =====================================================
   * RENDER
   * =====================================================
   */

  return (
    <>

      {/* =================================================
          MAIN NAVBAR
      ================================================= */}

      <nav
        className={`navbar ${
          scrolled
            ? "navbar-scrolled"
            : ""
        }`}
      >

        {/* =================================================
            TOP INFORMATION BAR
        ================================================= */}

        <div className="top-navbar">

          <div className="top-navbar-left">

            {/* LOCATION */}

            <div className="top-item">

              <FaMapMarkerAlt />

              <span>
            GreenLand Commnity, Upper Johnsonville TownShip - Left Bank 2B, Montserrade County, Liberia
              </span>

            </div>


            {/* PHONE */}

            <div className="top-item desktop-only">

              <FaPhoneAlt />

              <span>
                 Contact: +231-775-912-321 / +231-881-403-326 / +231-777-506-311
             </span>

            </div>

          </div>


          {/* SOCIAL MEDIA */}

          <div className="top-navbar-right">

            <span className="follow-text">
              Follow Us
            </span>


            <div className="top-socials">

              {/* FACEBOOK */}

              <a
                href="https://facebook.com"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Facebook"
              >
                <FaFacebookF />
              </a>


              {/* YOUTUBE */}

              <a
                href="https://youtube.com"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="YouTube"
              >
                <FaYoutube />
              </a>


              {/* EMAIL */}

              <a
                href="mailto:info@messiahmission.edu"
                aria-label="Email"
              >
                <FaEnvelope />
              </a>

            </div>

          </div>

        </div>


        {/* =================================================
            MAIN NAVIGATION
        ================================================= */}

        <div className="navbar-main">


          {/* =================================================
              LOGO / SCHOOL BRAND
          ================================================= */}

          <Link
            to="/"
            className="logo-section"
          >

            <img
              src={logo}
              alt="Exellent Kids Foundation"
              className="navbar-logo"
            />


            <div className="school-name">

              <h2>
                Excellent Kids Foundation
              </h2>

              <p>
                We deliver Excellence with Evidence
              </p>

            </div>

          </Link>


          {/* =================================================
              DESKTOP NAVIGATION
          ================================================= */}

          <ul className="nav-links">

            {navLinks.map(
              (link) => (

                <li
                  key={link.path}
                  className={
                    location.pathname ===
                    link.path
                      ? "active"
                      : ""
                  }
                >

                  <Link
                    to={link.path}
                    className={
                      link.button
                        ? "login-button"
                        : ""
                    }
                  >

                    {link.text}

                  </Link>

                </li>

              )
            )}

          </ul>


          {/* =================================================
              MOBILE MENU BUTTON
          ================================================= */}

          <button
            type="button"
            className="mobile-toggle"
            onClick={() =>
              setMenuOpen(
                !menuOpen
              )
            }
            aria-label={
              menuOpen
                ? "Close menu"
                : "Open menu"
            }
            aria-expanded={
              menuOpen
            }
          >

            {menuOpen ? (

              <IoClose />

            ) : (

              <HiOutlineMenuAlt3 />

            )}

          </button>

        </div>


        {/* =================================================
            MOBILE NAVIGATION
        ================================================= */}

        <div
          className={`mobile-menu ${
            menuOpen
              ? "show"
              : ""
          }`}
        >

          <ul>

            {navLinks.map(
              (link) => (

                <li
                  key={link.path}
                  className={
                    location.pathname ===
                    link.path
                      ? "active"
                      : ""
                  }
                >

                  <Link
                    to={link.path}
                    onClick={() =>
                      setMenuOpen(false)
                    }
                  >

                    {link.text}

                  </Link>

                </li>

              )
            )}

          </ul>


          {/* =================================================
              MOBILE DIVIDER
          ================================================= */}

          <div className="mobile-divider"></div>


          {/* =================================================
              MOBILE SOCIAL MEDIA
          ================================================= */}

          <div className="mobile-socials">

            {/* FACEBOOK */}

            <a
              href="https://facebook.com"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Facebook"
            >
              <FaFacebookF />
            </a>


            {/* YOUTUBE */}

            <a
              href="https://youtube.com"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="YouTube"
            >
              <FaYoutube />
            </a>


            {/* EMAIL */}

            <a
              href="mailto:info@messiahmission.edu"
              aria-label="Email"
            >
              <FaEnvelope />
            </a>

          </div>

        </div>

      </nav>


      {/* =================================================
          NAVBAR SPACING
          Pushes page content below fixed navbar
      ================================================= */}

      <div className="navbar-spacing"></div>

    </>
  );
};


export default Navbar;